module.exports = __webpack_public_path__ + "img/banner-01.bf1dd65e.jpg";